import {
  File,
  FileAudio,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
} from "lucide-react"
import type { LucideProps } from "lucide-react"

const iconMap: Record<string, { icon: React.FC<LucideProps>; color?: string }> =
  {
    // Word documents
    doc: { icon: FileText, color: "text-[#2b579a]" },
    docx: { icon: FileText, color: "text-[#2b579a]" },
    // Images
    gif: { icon: FileImage },
    jpg: { icon: FileImage },
    jpeg: { icon: FileImage },
    png: { icon: FileImage },
    // Audio
    mp3: { icon: FileAudio },
    // Video
    mp4: { icon: FileVideo },
    // PDF
    pdf: { icon: FileText, color: "text-[#F40F02]" },
    // Excel
    xls: { icon: FileSpreadsheet, color: "text-[#217346]" },
    xlsx: { icon: FileSpreadsheet, color: "text-[#217346]" },
  }

interface FileIconProps {
  fileType: string | null | undefined
  className?: string
}

export function FileIcon({ fileType, className = "h-5 w-5" }: FileIconProps) {
  const ext = fileType?.toLowerCase().trim().replace(".", "") ?? ""
  const entry = iconMap[ext]
  const Icon = entry?.icon ?? File
  const colorClass = entry?.color ?? ""

  return <Icon className={`${className} ${colorClass}`} />
}
